import api from './BaseService'

async function consultarPessoaExiste(cpf, codigoCliente){
    const {statusText, data} = await api.get(`pessoas/cpf/${cpf}/codigoCliente/${codigoCliente}`);
     const pessoaExiste = statusText=="OK" && Boolean(data);
    return pessoaExiste
}
async function cadastrarPessoa(pessoa){    
    const {codigoCliente} = pessoa;   
    const resultPessoa = await api.post(`pessoas/${codigoCliente}`,pessoa);       
    return resultPessoa;
}

async function atualizarPessoa(pessoa){    
    const {codigoCliente} = pessoa;   
    const resultPessoa = await api.put(`pessoas/${codigoCliente}`,pessoa);       
    return resultPessoa;
}

async function obterDadosPessoaLogada(){
    let result ={};
    const {statusText,data} = await api.get(`pessoas/me`);
    if(statusText == "OK"){
        result = {...data};
    }
    return result;
}

const pessoaService ={
    consultarPessoaExiste,
    cadastrarPessoa,
    atualizarPessoa,
    obterDadosPessoaLogada
}

export default pessoaService;


// WEBPACK FOOTER //
// ./src/services/PessoaService.js